import {
  CREATE_SCHEMA_BRANCH,
  DELETE_SCHEMA_BRANCH,
  GET_SCHEMA_BRANCH,
  getResourceString,
  LIST_SCHEMA_BRANCHES,
  PROMOTE_SCHEMA_BRANCH
} from '@takeshape/actions';
import { usePermission } from 'app/permissions/hooks';
import { getCurrentProjectId } from 'app/project';
import { useSelector } from 'react-redux';

export type BranchPermissions = {
  canList: boolean;
  canGet: boolean;
  canCreate: boolean;
  canDelete: boolean;
  canPromote: boolean;
};

export function useBranchPermissions(): BranchPermissions {
  const projectId = useSelector(getCurrentProjectId);
  const resource = getResourceString('project', { projectId });
  const canList = usePermission(resource, LIST_SCHEMA_BRANCHES);
  const canGet = usePermission(resource, GET_SCHEMA_BRANCH);
  const canCreate = usePermission(resource, CREATE_SCHEMA_BRANCH);
  const canDelete = usePermission(resource, DELETE_SCHEMA_BRANCH);
  const canPromote = usePermission(resource, PROMOTE_SCHEMA_BRANCH);
  return {
    canList,
    canGet,
    canCreate,
    canDelete,
    canPromote
  };
}
